import { useEffect, useLayoutEffect } from 'react';

/**
 * `useLayoutEffect` on the client, `useEffect` on the server. React warns when
 * `useLayoutEffect` runs during SSR, so measurement effects should use this
 * instead to stay quiet while still measuring before the first paint.
 */
export const useIsomorphicLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
